import { Attributes, LookupBase } from '@singularsystems/neo-core';
import { DateCycleType } from '../DateCycleType';
import { DayOfMonthType } from '../DayOfMonthType.enum';

export default class DateCycleLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public dateCycleId: number = 0;

    public name: string = "";

    public description: string = "";

    public dateCycleType: DateCycleType | null = null;

    public dayOfMonthType: DayOfMonthType | null = null;

    @Attributes.Integer()
    public ordinal: number = 0;

    public isLinkedToInvestment: boolean = false;

    // Client only properties / methods
}